import { mapperModuleNavigationLink } from '#layers/core/data-layer/modules/mappers'
import mapperIcon from '#layers/core/data-layer/utils/mappers/mapper-icon'
import type { MapperOptions } from '~/types'

export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  return {
    contentType: data.contentType || '',
    id: data.sys?.id || '',
    title: data.title || '',
    text: data.description || '',
    primaryLink: mapperModuleNavigationLink(data.link, options.getUrl),
    icon: mapperIcon(data.icon || '')
  }
}
